(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");

		sliders.forEach((slider, index) => {
			const productSlider = new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: ".product-button-group .swiper-button-next",
					prevEl: ".product-button-group .swiper-button-prev",
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: false,
				},
			});
		});
	};

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();

// 商品カードの写真を押したら商品ページへ（スマホ・タブレット）。写真のスライドが指の動きを止めるため、Safari ではリンクが押されたことにならない。
// そこで、写真の上で指をほとんど動かさずに離したときに、自分で商品ページへ移る。左右に動かしたとき（写真の切り替え）は移らない
(function () {
	if (window.__gpCardTap) return; // このファイルが1ページに何回読み込まれても、1回だけ
	window.__gpCardTap = true;
	var start = null, movedAt = 0, lastScroll = 0;
	// 勢いよくスクロールしている途中に指で止めたときは、移らない
	document.addEventListener("scroll", function () { lastScroll = Date.now(); }, { capture: true, passive: true });
	document.addEventListener("pointerdown", function (e) {
		var a = e.target.closest && e.target.closest(".gp-card-slide-link");
		start = a && e.pointerType !== "mouse" && Date.now() - lastScroll > 150 ? { a: a, x: e.clientX, y: e.clientY, t: Date.now() } : null;
	}, true);
	document.addEventListener("pointercancel", function () { start = null; }, true);
	document.addEventListener("pointerup", function (e) {
		var s = start;
		start = null;
		if (!s || Math.abs(e.clientX - s.x) > 5 || Math.abs(e.clientY - s.y) > 5 || Date.now() - s.t > 600) return;
		movedAt = Date.now();
		window.location.href = s.a.href;
	}, true);
	// Chrome など、あとからリンクも押されたことになるブラウザでは、二重に移らないように止める
	document.addEventListener("click", function (e) {
		if (Date.now() - movedAt < 1000 && e.target.closest && e.target.closest(".gp-card-slide-link")) e.preventDefault();
	}, true);
})();
